import PricelistTable from './PricelistTable';

export default PricelistTable;
